module.exports = __webpack_public_path__ + "ee81afbd0a1c7652a0710218346daae0.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_19.jpg
 ** module id = 601
 ** module chunks = 0
 **/